import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from '../../util/reactIntl';
import { LISTING_STATE_DRAFT } from '../../util/types';
import { ListingLink } from '../../components';
import { EditListingPricingForm } from '../../forms';
import { ensureOwnListing } from '../../util/data';
import { types as sdkTypes } from '../../util/sdkLoader';
import config from '../../config';

import css from './EditListingPricingPanel.module.css';
import FieldTextInput from '../FieldTextInput/FieldTextInput';

const { Money } = sdkTypes; 

const EditListingPricingPanel = props => {
  const {
    className,
    rootClassName,
    listing,
    disabled,
    ready,
    onSubmit,
    onChange,
    submitButtonText,
    panelUpdated,
    updateInProgress,
    errors,
    isChecked,
    setIsChecked
  } = props;

  const classes = classNames(rootClassName || css.root, className);
  const currentListing = ensureOwnListing(listing);

  const { price, publicData } = currentListing.attributes;


  const subscriptionPrice = publicData.subscriptionPrice ? new Money(publicData.subscriptionPrice, config.currency) : null;

  const isPublished = currentListing.id && currentListing.attributes.state !== LISTING_STATE_DRAFT;
  const panelTitle = isPublished ? (
    // <FormattedMessage
    //   id="EditListingPricingPanel.title"
    //   values={{ listingTitle: <ListingLink listing={listing} /> }}
    // />

    <FormattedMessage id="EditListingPricingPanel.createListingTitle" />
  ) : (
    <FormattedMessage id="EditListingPricingPanel.createListingTitle" />
  );

  const priceCurrencyValid = price instanceof Money ? price.currency === config.currency : true;
  const form = priceCurrencyValid ? (
    <EditListingPricingForm
      className={css.form}
      initialValues={{ price, subscriptionPrice }}
      onSubmit={onSubmit}
      onChange={onChange}
      saveActionMsg={submitButtonText}
      disabled={disabled}
      ready={ready}
      updated={panelUpdated}
      updateInProgress={updateInProgress}
      fetchErrors={errors}
      currentListing={currentListing}
      isChecked={isChecked}
      setIsChecked={setIsChecked}
    />
  ) : (
    <div className={css.priceCurrencyInvalid}>
      <FormattedMessage id="EditListingPricingPanel.listingPriceCurrencyInvalid" />
    </div>
  );

  return (
    <div className={classes}>
      <h1 className={css.titleText}>À quel prix souhaitez-vous louer votre place (par jour) ?
      <p className={css.underTitle}>Ce prix n’est pas définitif, vous pourrez le modifier ultérieurement depuis votre espace personnel</p>
      </h1>
      {/* <Form className={classes} >
        <FieldTextInput 
        className={css.inputPrice}
        type="text"
        />
      </Form> */}
      {form} 
      {/* <FieldTextInput /> */}
     
      {/* <div className={css.class}>
        <input type='text' placeholder='Definir votre prix...' className={css.input} />
      </div> */}
      

      {/* <h1 className={css.title}>{panelTitle}</h1> */}
       
    </div>
  );
};

const { func, object, string, bool } = PropTypes;

EditListingPricingPanel.defaultProps = {
  className: null,
  rootClassName: null,
  listing: null,
};

EditListingPricingPanel.propTypes = {
  className: string,
  rootClassName: string,

  // We cannot use propTypes.listing since the listing might be a draft.
  listing: object,

  disabled: bool.isRequired,
  ready: bool.isRequired,
  onSubmit: func.isRequired,
  onChange: func.isRequired,
  submitButtonText: string.isRequired,
  panelUpdated: bool.isRequired,
  updateInProgress: bool.isRequired,
  errors: object.isRequired,
};

export default EditListingPricingPanel;
